<template>
    <div>
        <v-card dark :color="COLOR.MAIN_COLOR">
            <v-card-text class="px-2 white--text">
                <p>
                    <span class="text-color-btn font-weight-bold">Chú ý:</span>
                    <br>
                    <br>
                    - Ngiêm cấm Buff các ID Seeding có nội dung vi phạm pháp luật, chính trị, đồ trụy... Nếu cố tình buff bạn sẽ bị trừ hết tiền và band khỏi hệ thống vĩnh viễn, và phải chịu hoàn toàn trách nhiệm trước pháp luật.
                    <br>
                    <br>
                    - Hệ thống sử dụng 99% tài khoản người VN, fb thật để tương tác like, comment, share....
                    <br>
                    <br>
                    - Hỗ trợ trang cá nhân và fanpage. Khi đăng bài viết mới hệ thống sẽ tự động quét và tăng tương tác theo yêu cầu của gói
                    <br>
                    <br>
                    - Không bảo hành số lượng tương tác, Tự động hoàn tiền số ngày chưa sử dụng nếu bạn hủy vip
                    <br>
                    <br>
                    - Vui lòng lấy đúng id vip cần tạo và check kỹ vip tránh tạo nhầm, tính năng đang trong giai đoạn thử nghiệm nên sẽ không hoàn tiền nếu bạn tạo nhầm
                    <br>
                    <br>
                    - Tốc độ tăng nhanh chậm ngẫu nhiên tránh bị facebook phát hiện.
                    <br>


                </p>

            </v-card-text>
        </v-card>
    </div>

</template>

<script>
    import { COLOR } from "~/config/constant";
    export default {
        name: "attention",

        data() {
            return {
                // Color chinh
                COLOR: COLOR,
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .text-color-btn {
        color: $clickMenuColor;
    }

</style>
